import { React, useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import FormikInput, { FormikLabel } from "../Formik/FormikInput";
import FormikSelect from "../Formik/FormikSelect";
import { backgroundColor, primaryColor } from "../../utilities/colors";
import { useSession } from "../../authentications/SessionContext";
import { findAndAddOption } from "../../utilities/findAndAddOption";
import Translator from "./Translator";
import DropdownTreeSelect from "react-dropdown-tree-select";
import "react-dropdown-tree-select/dist/styles.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useFormikContext } from "formik";

const GeneralContainer = styled.div`
  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #ccc !important;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #f3f3f3 !important;
    border-radius: 13px !important;
  }
  .form-check-input:checked {
    background-color: ${(props) => props.theme.primaryColor.primary};
  }
  .extra_price_text {
    width: 160px;
    max-with: 170px;
    font-sixe: 1vw;
    margin: 18px 0px 0px 10px;
    color: ${(props) => props.theme.primaryColor.primary};
    font-weight: 500;
    text-align: center;
  }
  .abx {
    width: 900px;
  }
`;

const CheckboxInput = ({
  // disabled,
  name,
  type = "checkbox",
  label,
  readOnly,
}) => {
  return (
    <div className="col-md-6 mt-3 mb-3">
      <FormikInput
        disabled={true}
        type={type}
        name={name}
        // style={{ accentColor: `${primaryColor.primary} !important` }}

        // label="Side Menu Link Active"
      />
      {label && (
        <FormikLabel name={name} className="ps-2">
          {label}
        </FormikLabel>
      )}
    </div>
  );
};
const Vtex = ({
  disabled,
  productBrand,
  setProductBrand,
  productTags,
  handleCustomSearch,
  handleCreateTags,
  handleCreateBrand,
  // setFieldValue,
  productList,
  publicCategoriesList,
  setPublicCategoriesList,
  productId,
  fieldName,
  fieldValue,
  isCreateModalOpen,
  setIsCreateModalOpen,
  updatedData,
  setUpdatedData,
  formData,
}) => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { sessionInfo } = useSession();
  const dropdownRef = useRef(null);
  const wrapperRef = useRef(null);
  const [placeholder, setPlaceholder] = useState("Search or Select...");
  const { setFieldValue, setFieldTouched, errors, touched } =
    useFormikContext();
  const [tags, setTags] = useState([]);
  const {
    is_vtex_admin,
    is_vtex_omantal,
    is_admin,
    is_merchant,
    isVTEX,
    company_id,
  } = sessionInfo;
  // const [data, setData] = useState(data);
  // console.log(
  //   "is_merchant,is_vtex_admin, in produc vtex tab",
  //   is_merchant,
  //   is_vtex_admin
  // );

  const preProcessNodes = (nodesList) => {
    if (nodesList?.length === 0) return [];
    return nodesList.map((node) => {
      return {
        ...node,
        checked: false,
        children: preProcessNodes(node.children || []),
      };
    });
  };

  const checkSelectedNode = (
    currentNode,
    nodeList,
    parentFound = false,
    parentSkip = false
  ) => {
    let currentSkip = parentSkip;
    let currentFound = parentFound;
    const list = nodeList.map((op) => {
      if (currentNode.value === op.value) {
        currentFound = true;
        currentSkip = true;

        return { ...op, checked: currentNode.value, expanded: false };
      } else {
        if (currentSkip) return { ...op, expanded: false, checked: false };
        let childList = [];
        if (op?.children?.length > 0) {
          const { list, childFound, childSkip } = checkSelectedNode(
            currentNode,
            op.children,
            currentFound,
            currentSkip
          );
          currentFound = childFound;
          childList = list;
          currentSkip = childSkip;
        }
        return {
          ...op,
          children: childList,
          checked: false,
          expanded: currentFound,
        };
      }
    });
    return {
      list,
      childFound: currentFound,
      childSkip: currentSkip,
    };
  };
  const onChange = (currentNode, selectedNodes) => {
    // console.log("triggered");
    const preprocessedListOptions = preProcessNodes(publicCategoriesList);
    if (currentNode.checked) {
      const { list } = checkSelectedNode(
        currentNode,
        preprocessedListOptions,
        false
      );

      setTimeout(() => {
        const tag = document.getElementById(`${currentNode._id}_tag`);
        // console.log("get onchange tag", tag);
        if (tag) {
          // console.log(currentNode, "asasas");
          tag.childNodes[0].replaceWith(currentNode.tag_to_show);
        }
      }, 100);
      setFieldValue("public_categ_ids", [currentNode.value]);
      setPublicCategoriesList([...list]);
    } else {
      setPublicCategoriesList(preprocessedListOptions);
    }
    // if (dropdownRef?.current?.state?.tags?.length > 0) {
    //   const updatedTags = dropdownRef.current.state.tags.map((tag) => ({
    //     ...tag,
    //     label: tag.full_label,
    //   }));

    //   setTags(updatedTags);
    //   setTimeout(() => {
    //     dropdownRef.current.setState(
    //       {
    //         ...dropdownRef.current.state,
    //         tags,
    //       },
    //       () => {
    //         console.log(
    //           "State updated after 1 second:",
    //           dropdownRef.current.state.tags
    //         );
    //       }
    //     );
    //   }, 200);
    //   console.log("updatedTags,tags", updatedTags, tags);
    // }
    // console.log("dropdownRef", dropdownRef);
    if (selectedNodes.length > 0) {
      setPlaceholder(" "); // Placeholder empty if something is selected
    } else {
      setPlaceholder("Search or Select...");
    }
    // Close the dropdown
    if (dropdownRef.current) {
      dropdownRef.current.setState({
        ...dropdownRef.current.state,
        showDropdown: false, // Set dropdown state to closed
      });
    }
  };
  // Using the existing handleOutsideClick
  const handleClickOutside = (event) => {
    // console.log("first", wrapperRef.current, event.target);

    if (dropdownRef.current && !wrapperRef.current.contains(event.target)) {
      dropdownRef.current.setState({
        ...dropdownRef.current.state,
        showDropdown: false, // Set dropdown state to closed
      });
    }
  };

  // Attach and clean up the click outside listener
  useEffect(() => {
    // console.log("formData", formData);
    if (formData?.public_categ_ids.length > 0) {
      setPlaceholder(" ");
    } else {
      setPlaceholder("Search or Select...");
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // useEffect(() => {
  //   // Initialize or fetch tags
  //   if (dropdownRef?.current?.state?.tags?.length > 0) {
  //     const updatedTags = dropdownRef.current.state.tags.map((tag) => ({
  //       ...tag,
  //       label: tag.full_label,
  //     }));
  //     setTags(updatedTags);
  //   }
  // }, [dropdownRef]);

  // useEffect(() => {
  //   console.log("tags got changed", tags);
  //   if (dropdownRef.current) {
  //     setTimeout(() => {
  //       dropdownRef.current.setState(
  //         {
  //           ...dropdownRef.current.state,
  //           tags,
  //         },
  //         () => {
  //           console.log(
  //             "State updated after 1 second:",
  //             dropdownRef.current.state.tags
  //           );
  //         }
  //       );
  //     }, 200);
  //   }
  // }, [tags]);

  return (
    <GeneralContainer>
      <div className="row ">
        {is_vtex_admin && is_vtex_omantal && (
          <>
            <div className="col-12">
              <h4>Connection Status</h4>
            </div>
            <CheckboxInput
              disabled={true}
              name="availble_on_vtex"
              label="Available on VTEX"
              readOnly
            />
            <div className="col-12">
              <FormikInput
                disabled={true}
                type="text"
                name="vtex_status"
                label="VTEX Status"
                readOnly
              />
            </div>
          </>
        )}
        <div className="col-12 mt-3">
          <h4>Brand</h4>
        </div>
        {/* <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="number"
            name="DepartmentId"
            label="DepartmentId"
          />
        </div>

        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="number"
            name="TaxCode"
            label="Tax Code"
          />
        </div> */}
        <div className="col-md-6 d-none">
          <FormikSelect
            disabled={disabled}
            options={productTags}
            placeholder="Search or Select..."
            name="product_tags_ids"
            label="Product Tags"
            handleSearch={({ ...args }) =>
              handleCustomSearch({ ...args, model: "product.template.tags" })
            }
            isMulti
            handleCreate={handleCreateTags}
          />
        </div>
        <div className="col-md-6">
          {!is_vtex_admin ? (
            <FormikSelect
              disabled={disabled}
              options={productBrand}
              placeholder="Search or Select..."
              name="VtexBrand"
              label={t["Product Brand"]}
              handleSearch={({ ...args }) =>
                handleCustomSearch({ ...args, model: "product.template.brand" })
              }
              onChange={(op) => {
                // console.log(op, "VtexBrand");
                findAndAddOption({
                  incomingOption: [op.value, op.label],
                  setAvailableOptions: setProductBrand,
                });
              }}
            />
          ) : (
            <FormikSelect
              disabled={disabled}
              options={productBrand}
              placeholder="Search or Select..."
              name="VtexBrand"
              label={t["Product Brand"]}
              handleSearch={({ ...args }) =>
                handleCustomSearch({ ...args, model: "product.template.brand" })
              }
              onChange={(op) => {
                // console.log(op, "VtexBrand");
                findAndAddOption({
                  incomingOption: [op.value, op.label],
                  setAvailableOptions: setProductBrand,
                });
              }}
              handleCreate={handleCreateBrand}
            />
          )}
        </div>
        {isVTEX && (
          <>
            <div className="col-12 mt-3">
              <h4>Shop</h4>
            </div>
            <div ref={wrapperRef} id="treeDropdownWrapper" className="col-md-6">
              <label
                htmlFor="public_categ_ids"
                className="form-label"
                style={{
                  color: "#535559",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "500",
                  marginRight: "10px",
                }}
              >
                {t["Categories"]}
              </label>
              <DropdownTreeSelect
                ref={dropdownRef}
                name="public_categ_ids"
                disabled={disabled}
                data={publicCategoriesList}
                mode="hierarchical"
                onChange={onChange}
                // searchPredicate={() => {
                //   console.log("first");
                // }}
                className="tree-select"
                texts={{
                  placeholder,
                }}
                styles={{
                  minHeight: "58px",
                  borderRadius: "15px",
                  border: "1px solid #CBCBCB",
                  background: "#F5F5F5",
                  boxShadow: "0 !important",
                  "&:hover": {
                    border: "1px solid #CBCBCB !important",
                  },
                }}
              />
              {touched["public_categ_ids"] && errors["public_categ_ids"] && (
                <span className="ps-2 error-message">
                  {errors["public_categ_ids"]}
                </span>
              )}
            </div>
            {/* <div className="col-md-6">
              <FormikSelect
                disabled={disabled}
                options={publicCategoriesList}
                placeholder="Search or Select..."
                label={t["Categories"]}
                name="public_categ_ids"
                isMulti
                handleSearch={({ ...args }) => {
                  handleCustomSearch({
                    ...args,
                    model: "product.public.category",
                  });
                }}
                onChange={(op, event) => {
                  // console.log(event, "public_categ_ids.......................");
                  if (event?.option) {
                    findAndAddOption({
                      incomingOption: [event.option.value, event.option.label],
                      setAvailableOptions: setPublicCategoriesList,
                    });
                    return;
                  }
                  if (!event?.option) {
                    findAndAddOption({
                      incomingOption: [op.value, op.label],
                      setAvailableOptions: setPublicCategoriesList,
                    });
                    return;
                  }
                }}
              />
            </div> */}
            {/* {is_vtex_admin && is_vtex_omantal && ( */}
            <div className="col-md-6">
              <FormikSelect
                name="alternative_product_ids"
                isMulti
                disabled={disabled}
                placeholder="Search or Select..."
                label={t["Alternative Products"]}
                handleSearch={({ ...args }) => {
                  handleCustomSearch({ ...args, model: "product.template" });
                }}
                options={productList}
              />
            </div>
            <div className="col-sm-12" style={{ position: "relative" }}>
              <div className="col-12 mt-3">
                <h4>Product Description</h4>
              </div>
              {!disabled && (
                <Translator
                  productId={productId}
                  color={primaryColor.primary}
                  fieldName={fieldName}
                  fieldValue={fieldValue}
                  isCreateModalOpen={isCreateModalOpen}
                  setIsCreateModalOpen={setIsCreateModalOpen}
                  updatedData={updatedData}
                  setUpdatedData={setUpdatedData}
                />
              )}
              <FormikInput
                disabled={disabled}
                name="description_sale"
                textArea
                label={t["Description"] + "*"}
              />
            </div>
          </>
        )}

        {/* <div className="col-md-6">
            <FormikInput
              disabled={disabled}
              type="number"
              name="Score"
              label="Score"
            />
          </div> */}
        {/* <div className="col-12 mt-3">
          <h4>Specification</h4>
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="char"
            name="spec_name"
            label="Name"
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="char"
            name="spec_Description"
            label="Description"
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="number"
            name="spec_CategoryId"
            label="Category Id"
          />
        </div>

        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="number"
            name="spec_FieldGroupId"
            label="Group Id"
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="number"
            name="spec_Position"
            label="Position"
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="char"
            name="spec_DefaultValue"
            label="Default Value"
          />
        </div>
        <CheckboxInput
          label=" Link Active"
          name="spec_IsSideMenuLinkActive"
          disabled={disabled}
        />

        <CheckboxInput
          disabled={disabled}
          name="spec_IsFilter"
          label="Filter"
        />

        <CheckboxInput
          disabled={disabled}
          name="spec_IsRequired"
          label="Required"
        />
        <CheckboxInput
          disabled={disabled}
          name="spec_IsOnProductDetails"
          label="Is On Product Details"
        />
        <CheckboxInput
          disabled={disabled}
          name="ShowWithoutStock"
          label="Show Without Stock"
        />
        <CheckboxInput
          disabled={disabled}
          name="spec_IsStockKeepingUnit"
          label="Stock Keeping Unit"
        />

        <CheckboxInput
          disabled={disabled}
          name="spec_IsWizard"
          label="Wizard"
        />
        <CheckboxInput
          disabled={disabled}
          name="VtexStatus"
          label="Active "
        />

        <CheckboxInput
          disabled={disabled}
          name="spec_IsTopMenuLinkActive"
          label="Top Menu Link Active "
        /> */}
      </div>
    </GeneralContainer>
  );
};

export default Vtex;
